//external
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Icon } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import RefreshIcon from '@material-ui/icons/Refresh';
//internall
import { getIntentions, getAllows } from 'services/rtpi/intentions/service';
import { startRequest, finishRequest } from 'store/modules/loading/actions';
import ContentPanel from 'components/ContentPanel';
import DataTableLoading from 'components/DataTableLoading';
import { setMessage } from 'store/modules/message/action';
import { useDebounce } from 'utils/uiUtils';
import { formatDateTime } from 'utils/formatUtil';
import GridContainer from 'components/v2/grid';
import InputText from 'components/v2/inputText';
import TableAction from 'components/v2/tableAction';
import { sanitizeErrorUI } from 'utils/errorUtil';
import DataTableReact from 'components/v2/dataTableReact';
import { FilterRtpiIntention } from '..';
//style
import { IconContainer } from './styled';

export default function Intention() {
  const message = useSelector(state => state.message.data);
  const [intentions, setIntentions] = useState();
  const [allows, setAllows] = useState({});
  //Pagination
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [sort, setSort] = useState();
  const [reload, setReload] = useState(0);

  const { filter, setFilter } = useContext(FilterRtpiIntention);

  const debouncedSearchTerm = useDebounce(filter.search);
  
  const dispatch = useDispatch();

  const columns = [
    {
      maxWidth: "10%",
      name: 'Filial',
      selector: 'protheusBranch',
      sortable: true,
    },
    {
      maxWidth: "10%",
      name: 'Código',
      selector: 'protheusCode',
      sortable: true,
    },
    {
      maxWidth: "20%",
      name: 'Descrição',
      selector: 'productDescription',
      sortable: true,
    },
    {
      maxWidth: "13%",
      name: 'Rev. Anterior',
      selector: 'oldRev',
      sortable: true,
    },
    {
      maxWidth: "12%",
      name: 'Rev. Atual',
      selector: 'newRev',
      sortable: true,
    },
    {
      maxWidth: "15%",
      name: 'Data',
      selector: 'createdAt',
      sortable: true,
    },
    {
      maxWidth: "20%",
      style: {justifyContent: "flex-end"},
      cell: row => 
        <div>
          <IconContainer>
            <TableAction 
              title={"Editar"} 
              disabled={!allows.put} 
              to={`/premixlabel/rtpi/rtpi_intention/edit/${row.id}`}
            >
              <EditIcon/>
            </TableAction>
            <TableAction title={row.reason} disableRipple isLink={false}>
              <Icon>info</Icon>
            </TableAction>
            <TableAction 
              title={"Aprovar/Reprovar"} 
              disabled={!allows.put} 
              to={`/premixlabel/rtpi/rtpi_intention/approve/${row.id}`}
            >
              <Icon>manage_search</Icon>
            </TableAction>
          </IconContainer>
        </div>
    }
  ];

  useEffect(() => {
    getAllows().then(data => {
      setAllows(data.data)
    }).catch(err => {
      dispatch(setMessage(sanitizeErrorUI(err)));
    });
  }, [dispatch]);

  const actions = [
    <div key='refresh'>
      <TableAction 
      title={"Atualizar"} 
      onClick={refreshHandler}
      isLink={false}>
        <RefreshIcon/>
      </TableAction>
    </div>
  ];

  function refreshHandler() {
    setReload(reload + 1);
  }

  useEffect(() => {
    setLoading(true);
    dispatch(startRequest());    
    getIntentions(debouncedSearchTerm, perPage, filter.page, sort).then(data => {
      setTotalRows(parseInt(data.headers['recordcount']));
      setIntentions(data.data.map(value => {
        value.createdAt = formatDateTime(new Date(value.createdAt));
        return value;
      }));
    }).catch(err => {
      dispatch(setMessage(sanitizeErrorUI(err)));
    }).finally(() => {
      dispatch(finishRequest());
      setLoading(false);
    });
  }, [debouncedSearchTerm, dispatch, filter.page, perPage, sort, reload, setFilter]);

  const handlePageChange = (page) => {
    setFilter({...filter, page});
  };

  const handlePerRowsChange = (perPage) => {
    setPerPage(perPage);
  };

  const handleSort = (column, sortDirection) => {
    setSort(`${column.selector} ${sortDirection}`);
  };

  return (
    <>
      <ContentPanel message={message} title="Intenções" actions={actions}>
        <GridContainer>
          <InputText
            xs={12}
            name="search"
            label="Pesquisar"
            type="text"
            placeholder="Pesquisar"
            value={filter.search}
            onChange={(e) => setFilter({page: 1, search: e.target.value})}
            hasWarning={false}
          />
        </GridContainer>

        <DataTableReact
          fixedHeader
          progressPending={loading}
          progressComponent={<DataTableLoading />}
          columns={columns}
          data={intentions}
          pagination
          paginationServer
          paginationTotalRows={totalRows}
          onChangeRowsPerPage={handlePerRowsChange}
          onChangePage={handlePageChange}
          sortServer
          onSort={handleSort}
          paginationDefaultPage={filter.page}
        />
      </ContentPanel>
    </>
  )
}